// import React, { useEffect, useState, useContext } from "react";
// import { useHistory } from "react-router-dom";
// import styles from "./LowStockPage.module.css";
// import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@material-ui/core";
// import { StockContext } from "../../Context/StockContext";
// import * as api from "../../api/index";
// import { useSnackbar } from "react-simple-snackbar";
// import { useDispatch } from "react-redux";
// import { createStockAdjustmentt } from "../../actions/stockAdjustmentActions";
// import { createStock } from "../../actions/stockActions";
// import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// import axios from "axios";

// const LowStockPage = () => {
//   const history = useHistory();
//   const dispatch = useDispatch();
//   const { getCurrentStockQty } = useContext(StockContext);
//   const [openSnackbar] = useSnackbar({
//     position: "bottom",
//     style: {
//       backgroundColor: "#2e7d32",
//       color: "#fff",
//       fontFamily: "Roboto, sans-serif",
//       fontSize: "16px",
//       textAlign: "center",
//     },
//   });

//   const [lowStockItems, setLowStockItems] = useState([]);
//   const [reorderDialogOpen, setReorderDialogOpen] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [reorderQuantity, setReorderQuantity] = useState("");
//   const [reorderError, setReorderError] = useState("");
//   const user = JSON.parse(localStorage.getItem("profile"));

//   // Fetch low stock items
//   useEffect(() => {
//     const fetchLowStockItems = async () => {
//       try {
//         const { data: items } = await api.fetchItems();
//         const lowStock = [];
//         for (const item of items) {
//           if (
//             !item ||
//             !item.id ||
//             !item.itemName ||
//             !item.stockQty?.minQty ||
//             !item.toggleStock ||
//             !item.isActive ||
//             item.isDeleted
//           ) {
//             continue;
//           }
//           const stockData = await getCurrentStockQty(item.id);
//           if (stockData && stockData.currentStock <= item.stockQty.minQty) {
//             lowStock.push({
//               id: item.id,
//               name: item.itemName,
//               currentStock: stockData.currentStock,
//               minStock: item.stockQty.minQty,
//             });
//           }
//         }
//         setLowStockItems(lowStock);
//       } catch (error) {
//         console.error("Error fetching low stock items:", error);
//         setLowStockItems([]);
//       }
//     };
//     fetchLowStockItems();
//   }, [getCurrentStockQty]);

//   const handleBack = () => {
//     history.push("/dashboard");
//             // window.location.href = "/dashboard";

//   };

//   // Reorder dialog handlers
//   const handleOpenReorderDialog = (item) => {
//     setSelectedItem(item);
//     setReorderQuantity("");
//     setReorderError("");
//     setReorderDialogOpen(true);
//   };

//   const handleCloseReorderDialog = () => {
//     setReorderDialogOpen(false);
//     setSelectedItem(null);
//     setReorderQuantity("");
//     setReorderError("");
//   };

// //   const handleReorder = async () => {
// //     const quantity = parseFloat(reorderQuantity);
// //     if (isNaN(quantity) || quantity <= 0) {
// //       setReorderError("Please enter a valid quantity greater than 0");
// //       return;
// //     }

// //     try {
// //       const { data: count } = await axios.get(
// //         `${process.env.REACT_APP_API}/stockAdjustments/count?searchQuery=${user?.result?.id}`
// //       );
// //       const stockAdjustmentNumber = (count + 1).toString();

// //       const stockAdjustmentData = {
// //         items: [{ item: selectedItem.id, quantity }],
// //         adjustType: "Add",
// //         stockAdjustmentNumber,
// //         creator: [user?.result?.id || user?.result?.googleId],
// //         createdAt: new Date(),
// //         type: "StockAdjustment",
// //         status: "Completed",
// //         notes: `Reorder for ${selectedItem.name}`,
// //       };

// //       await dispatch(createStockAdjustmentt(stockAdjustmentData, history));

// //       const { data: items } = await api.fetchItems();
// //       const item = items.find((i) => i.id === selectedItem.id);
// //       if (!item || !item.units?.stock?.unit) {
// //         throw new Error(`Stock unit not found for item ${selectedItem.name}`);
// //       }

// //             const stockTransaction = {
// //               item: selectedItem.id,
// //               transactionType: "STOCK_ADJUSTMENT",
// //               qty: quantity,
// //               stockAdjustmentId: stockAdjustmentNumber,
// //               createdAt: new Date(),
// //               unit: item.units.stock.unit,
// //               references: {
// //                 stockAdjustmentId: stockAdjustmentNumber,
// //                 transactionRef: "Stock Adjustment Addition",
// //               },
// //               creator: user?.result?.id || user?.result?.googleId,
// //             };

// //             await dispatch(createStock([stockTransaction]));
// //             openSnackbar(`Successfully reordered ${quantity} units of ${selectedItem.name}`);
// //             handleCloseReorderDialog();

// //             const { data: refreshedItems } = await api.fetchItems();
// //             const lowStock = [];
// //             for (const item of refreshedItems) {
// //               if (
// //                 !item ||
// //                 !item.id ||
// //                 !item.itemName ||
// //                 !item.stockQty?.minQty ||
// //                 !item.toggleStock ||
// //                 !item.isActive ||
// //                 item.isDeleted
// //               ) {
// //                 continue;
// //               }
// //               const stockData = await getCurrentStockQty(item.id);
// //               if (stockData && stockData.currentStock <= item.stockQty.minQty) {
// //                 lowStock.push({ id: item.id, name: item.itemName });
// //               }
// //             }
// //             setLowStockItems(lowStock);
// //           } catch (error) {
// //             console.error("Error reordering stock:", error);
// //             setReorderError(error.message || "Failed to reorder stock.");
// //           }

// //   };

//    const handleReorder = async () => {
//      const quantity = parseFloat(reorderQuantity);
//      if (isNaN(quantity) || quantity <= 0) {
//        setReorderError("Please enter a valid quantity greater than 0");
//        return;
//      }

//      try {
//        // Generate stock adjustment number
//        const { data: count } = await axios.get(
//          `${process.env.REACT_APP_API}/stockAdjustments/count?searchQuery=${user?.result?.id}`
//        );
//        const stockAdjustmentNumber = (count + 1).toString();

//        // Create stock adjustment
//        const stockAdjustmentData = {
//          items: [{ item: selectedItem.id, quantity }],
//          adjustType: "Add",
//          stockAdjustmentNumber,
//          creator: [user?.result?.id || user?.result?.googleId],
//          createdAt: new Date(),
//          type: "StockAdjustment",
//          status: "Completed",
//          notes: `Reorder for ${selectedItem.name}`,
//        };

//        const stockAdjustmentResponse = await dispatch(createStockAdjustmentt(stockAdjustmentData, history));
//        console.log("Stock adjustment response:", stockAdjustmentResponse);

//        // Fetch item to get the correct stock unit
//        const { data: items } = await api.fetchItems();
//        const item = items.find((i) => i.id === selectedItem.id);
//        if (!item || !item.units?.stock?.unit) {
//          throw new Error(`Stock unit not found for item ${selectedItem.name}`);
//        }

//        // Create stock transaction
//        const stockTransaction = {
//          item: selectedItem.id,
//          transactionType: "STOCK_ADJUSTMENT",
//          qty: quantity,
//          stockAdjustmentId: stockAdjustmentNumber,
//          createdAt: new Date(),
//          unit: item.units.stock.unit, // Use id from item
//          references: {
//            stockAdjustmentId: stockAdjustmentNumber,
//            transactionRef: "Stock Adjustment Addition",
//          },
//          creator: user?.result?.id || user?.result?.googleId,
//        };

//        console.log("Stock transaction payload:", stockTransaction);
//        try {
//          const stockResponse = await dispatch(createStock([stockTransaction]));
//          console.log("Stock creation response:", stockResponse);
//        } catch (stockError) {
//          console.error("Error creating stock:", stockError);
//          throw new Error("Failed to create stock transaction");
//        }

//        openSnackbar(`Successfully reordered ${quantity} units of ${selectedItem.name}`);
//        window.location.reload();
//        handleCloseReorderDialog();

//        // Refresh low stock items
//        try {
//          const { data: items } = await api.fetchItems();
//          const lowStock = [];
//          for (const item of items) {
//            if (
//              !item ||
//              !item.id ||
//              !item.itemName ||
//              !item.stockQty?.minQty ||
//              !item.toggleStock ||
//              !item.isActive ||
//              item.isDeleted
//            ) {
//              continue;
//            }
//            try {
//              const stockData = await getCurrentStockQty(item.id);
//              if (stockData && stockData.currentStock <= item.stockQty.minQty) {
//                lowStock.push({ id: item.id, name: item.itemName });
//              }
//            } catch (error) {
//              console.warn(`Error refreshing stock for item ${item.id}:`, error);
//            }
//          }
//          console.log("Refreshed low stock items after reorder:", lowStock);
//          setLowStockItems(lowStock);
//        } catch (error) {
//          console.error("Error refreshing low stock items:", error);
//          setLowStockItems([]);
//          openSnackbar("Failed to refresh low stock items. Please try again.");
//        }
//      } catch (error) {
//        console.error("Error reordering stock:", error);
//        setReorderError(error.message || "Failed to reorder stock. Please try again.");
//      }
//    };

//   if (!user) history.push("/login");

//   return (
//     <div className={styles.container}>
//     <div className={styles.header}>
//       <Button
//         variant="contained"
//         className={styles.backButton}
//         onClick={handleBack}
//         startIcon={<ArrowBackIcon />}
//       >
//         Back to Dashboard
//       </Button>
//       <h1 className={styles.title}>Low Stock Items</h1>
//     </div>
//     {lowStockItems.length > 0 ? (
//       <div className={styles.tableWrapper}>
//         <table className={styles.table}>
//           <thead>
//             <tr>
//               <th>Item Name</th>
//               <th>Current Stock</th>
//               <th>Minimum Stock</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {lowStockItems.map((item) => (
//               <tr key={item.id} className={styles.tableRow}>
//                 <td>{item.name}</td>
//                 <td>{item.currentStock}</td>
//                 <td>{item.minStock}</td>
//                 <td>
//                   <Button
//                     variant="contained"
//                     className={styles.reorderButton}
//                     onClick={() => handleOpenReorderDialog(item)}
//                   >
//                     Reorder
//                   </Button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     ) : (
//       <div className={styles.noDataMessage}>No Low Stock Items</div>
//     )}

//     {/* Reorder Dialog */}
//     <Dialog open={reorderDialogOpen} onClose={handleCloseReorderDialog}>
//       <DialogTitle>Reorder Stock for {selectedItem?.name}</DialogTitle>
//       <DialogContent>
//         <TextField
//           label="Quantity to Add (units)"
//           type="number"
//           value={reorderQuantity}
//           onChange={(e) => {
//             setReorderQuantity(e.target.value);
//             setReorderError("");
//           }}
//           fullWidth
//           margin="normal"
//           error={!!reorderError}
//           helperText={reorderError}
//         />
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={handleCloseReorderDialog}>Cancel</Button>
//         <Button
//           onClick={handleReorder}
//           color="primary"
//           variant="contained"
//           disabled={reorderQuantity === ""}
//         >
//           Reorder
//         </Button>
//       </DialogActions>
//     </Dialog>
//   </div>
//   );
// };

// export default LowStockPage;

import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import styles from "./LowStockPage.module.css";
import { Button, Select, MenuItem } from "@material-ui/core";
import { StockContext } from "../../Context/StockContext";
import * as api from "../../api/index";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Spinner from "../Spinner/Spinner";
const LowStockPage = () => {
  const history = useHistory();
  const { getCurrentStockQty } = useContext(StockContext);
  const [lowStockItems, setLowStockItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // New loading state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const itemsPerPageOptions = [5, 10, 20];
  const user = JSON.parse(localStorage.getItem("profile"));

  // Fetch low stock items
  useEffect(() => {
    const fetchLowStockItems = async () => {
      try {
        setIsLoading(true);
        const { data: items } = await api.fetchItems();
        const lowStock = [];
        for (const item of items) {
          if (
            !item ||
            !item.id ||
            !item.itemName ||
            !item.stockQty?.minQty ||
            !item.toggleStock ||
            !item.isActive ||
            item.isDeleted
          ) {
            continue;
          }
          const stockData = await getCurrentStockQty(item.id);
          if (stockData && stockData.currentStock <= item.stockQty.minQty) {
            lowStock.push({
              id: item.id,
              name: item.itemName,
              currentStock: stockData.currentStock,
              minStock: item.stockQty.minQty,
            });
          }
        }
        setLowStockItems(lowStock);
      } catch (error) {
        console.error("Error fetching low stock items:", error);
        setLowStockItems([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchLowStockItems();
  }, [getCurrentStockQty]);

  const handleBack = () => {
    history.push("/dashboard");
  };

  // Pagination handlers
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = lowStockItems.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(lowStockItems.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1);
  };

  if (!user) history.push("/login");

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        {" "}
        <Spinner />{" "}
      </div>
    );
  }
  return (
    <div className={styles.container}>
      {" "}
      <div className={styles.header}>
        {" "}
        <Button
          variant="contained"
          className={styles.backButton}
          onClick={handleBack}
          startIcon={<ArrowBackIcon />}
        >
          {" "}
          Back to Dashboard{" "}
        </Button>{" "}
        <h1 className={styles.title}>Low Stock Items</h1>{" "}
      </div>{" "}
      {lowStockItems.length > 0 ? (
        <>
          {" "}
          <div className={styles.tableWrapper}>
            {" "}
            <table className={styles.table}>
              {" "}
              <thead>
                {" "}
                <tr>
                  {" "}
                  <th>Item Name</th> <th>Current Stock</th>{" "}
                  <th>Minimum Stock</th>{" "}
                </tr>{" "}
              </thead>{" "}
              <tbody>
                {" "}
                {currentItems.map((item) => (
                  <tr key={item.id} className={styles.tableRow}>
                    {" "}
                    <td>{item.name}</td> <td>{item.currentStock}</td>{" "}
                    <td>{item.minStock}</td>{" "}
                  </tr>
                ))}{" "}
              </tbody>{" "}
            </table>{" "}
          </div>{" "}
          <div className={styles.paginationContainer}>
            {" "}
            <Button
              variant="contained"
              className={styles.paginationButton}
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              {" "}
              Previous{" "}
            </Button>{" "}
            <span className={styles.pageInfo}>
              {" "}
              Page {currentPage} of {totalPages}{" "}
            </span>{" "}
            <Button
              variant="contained"
              className={styles.paginationButton}
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              {" "}
              Next{" "}
            </Button>{" "}
            <Select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              className={styles.itemsPerPageSelect}
            >
              {" "}
              {itemsPerPageOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {" "}
                  {option} per page{" "}
                </MenuItem>
              ))}{" "}
            </Select>{" "}
          </div>{" "}
        </>
      ) : (
        <div className={styles.noDataMessage}>No Low Stock Items</div>
      )}{" "}
    </div>
  );
};
export default LowStockPage;
